// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Devices.scss';
import { deviceModel } from './_variables';
import { portTypes } from '../Device/_variables';
import Device from './Modules/Device';


// COMPONENT
export default function Devices (props) {
   // States and Variables
   const [devices, setDevices] = useState(null);
   const [locations, setLocations] = useState(null);
   const [collections, setCollections] = useState(null);
   const [devicePopups, setDevicePopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Devices"); // set page title
      getDevices();
      getLocations();
      getCollections();
   }, []);

   // Functions
   const getDevices = function () {
      OHSCRUD({
         url: '/v1/oneport/devices',
         method: 'GET',
         success: function (data) {
            setDevices(OHSListDataFormatter(data, deviceModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getLocations = function () {
      OHSCRUD({
         url: '/v1/oneport/locations',
         method: 'GET',
         success: function (data) {
            setLocations(OHSListDataFormatter(data));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getCollections = function () {
      OHSCRUD({
         url: '/v1/oneport/collections',
         method: 'GET',
         success: function (data) {
            setCollections(OHSListDataFormatter(data));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addDevice = function () {
      OHSCRUD({
         url: '/v1/oneport/devices',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-devices-add'),
         success: function (data) {
            if (devices.length > 0) {
               setDevices([...devices, OHSListDataFormatter(data[0], deviceModel)]);
            } else {
               setDevices([OHSListDataFormatter(data[0], deviceModel)]);
            }
            OHSFormDataClearer('oneport-devices-add');
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div className="oneport-devices">
         <OHSAppHeader onehive={props.onehive} title="Devices" help="https://www.onehivesystems.com/documentation/oneport/devices" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-devices-add' title="Add a Device" onEnter={addDevice}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Location">
                  <OHSFormSelectBuilder content={locations} field='name' blank={false} ohsformdata="location_id" />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Collection">
                  <OHSFormSelectBuilder content={collections} field='name' blank={true} ohsformdata="collection_id" />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Number of Ports">
                  <input type='number' className='ohsinput' min={1} max={1000} defaultValue={1} data-ohsformdata='number_of_ports' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="IP Address">
                  <input type='text' className='ohsinput' data-ohsformdata='ip_address' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Initial Port Type">
                  <OHSFormSelectBuilder content={portTypes} simple={true} blank={false} ohsformdata='port_type' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Port Name Prefix">
                  <input type='text' className='ohsinput' placeholder='(Optional)' data-ohsformdata='port_name_prefix' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Port Name Suffix">
                  <input type='text' className='ohsinput' placeholder='(Optional)' data-ohsformdata='port_name_suffix' />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addDevice} clear={() => {OHSFormDataClearer('oneport-devices-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Devices" container='oneport-devices-list' />
            <OHSWidget onehive={props.onehive} id='oneport-devices-list' title="List of Devices">
               <OHSList onehive={props.onehive} content={devices} popups={devicePopups} setPopups={setDevicePopups} template={
                  <Device onehive={props.onehive} parent={{
                     devices: devices,
                     setDevices: setDevices,
                     locations: locations,
                     collections: collections
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}